import { Component, OnInit } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { FormBuilder, FormGroup } from '@angular/forms';
import { catchError } from 'rxjs/operators';
import { Router } from '@angular/router';
import { VesselCalculationInventoryService } from 'src/app/services/danish-shipping-services/vessel-calculation-inventory.service';

@Component({
  selector: 'app-recycling-option-create',
  templateUrl: './recycling-option-create.component.html',
  styleUrls: ['./recycling-option-create.component.css']
})
export class RecyclingOptionCreateComponent implements OnInit {
  recyclingForm: FormGroup;
  isSubmitting = false;
  categories: any[] = [];
  errors: any = {};
  countryInput: string = '';
  selectedCountries: string[] = [];
  availableCountries: string[] = [];


  constructor(
    private recyclingService: VesselCalculationInventoryService,
    private toastr: ToastrService,
    private fb: FormBuilder,
    private router: Router,
  ) {
    this.recyclingForm = this.fb.group({
      title: [''],
      coefficient: [''],
      percentage: [''],
      scenarioCategoryId: [null],
      description: [''],
      countryInput: ['']  
    });
  }

  ngOnInit(): void {
    this.loadCategories();
    this.loadAvailableCountries();

  }
  loadAvailableCountries(): void {
    this.recyclingService.getAvailableCountries().subscribe(response => {
      this.availableCountries = response;
    }, error => {
      console.error('Error fetching countries:', error);
    });
  }
  loadCategories(): void {
    this.recyclingService.getCategoriesForRecycling().subscribe(response => {
      this.categories = response;
    }, error => {
      console.error('Error fetching categories:', error);
    });
  }

  addCountry(): void {
    const country = this.recyclingForm.get('countryInput')?.value.trim();  
    if (country && !this.selectedCountries.includes(country)) {
      this.selectedCountries.push(country);
      this.recyclingForm.get('countryInput')?.setValue('');  
    }
  }

  removeCountry(country: string): void {
    this.selectedCountries = this.selectedCountries.filter(c => c !== country);
  }

  createRecyclingOption(): void {
    if (this.isSubmitting) return;

    this.isSubmitting = true;
    const data = {
      ...this.recyclingForm.value,
      countryNames: this.selectedCountries  
    };

    this.recyclingService.createRecyclingOption(data).pipe(
      catchError(error => {
        this.errors = {};
        if (error.status === 400 && Array.isArray(error.error)) {
          error.error.forEach((msg: string) => {
            if (msg.includes('Title')) this.errors.title = [...(this.errors.title || []), msg];
            else if (msg.includes('Percentage')) this.errors.percentage = [...(this.errors.percentage || []), msg];
            else if (msg.includes('Coefficient')) this.errors.coefficient = [...(this.errors.coefficient || []), msg];
            else if (msg.includes('ScenarioCategoryId')) this.errors.scenarioCategoryId = [...(this.errors.scenarioCategoryId || []), msg];
            else if (msg.includes('Description')) this.errors.description = [...(this.errors.description || []), msg];
            else this.errors.general = [...(this.errors.general || []), msg];
          });
        } else {
          this.toastr.error('An unexpected error occurred.');
        }
        return [];
      })
    ).subscribe(response => {
      this.toastr.success('Recycling Option created successfully!');
      this.recyclingForm.reset();
      this.selectedCountries = [];
      this.router.navigate(['/homeAdmin/v2/recyclingOptions']);
    }).add(() => {
      this.isSubmitting = false;
    });
  }
}